<template>
  <div>
      <section id="partners" >
        <b-row bg-variant="white" class="align-items-center">
          <b-col><img src="logo/airtel.png" alt="airtel" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/tnm.png" alt="TNM" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/taura.jpg" alt="Taura" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/econet.jpg" alt="Econet" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/netone.jpg" alt="Netone" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/telecel.png" alt="Telecel" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/mtn.png" alt="MTN" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/vodacom.png" alt="Vodacom" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/telkom.png" alt="Telkom" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/cellc.png" alt="CellC" style="max-height: 50px; object-fit: contain;" /></b-col>
          <b-col><img src="logo/gain.png" alt="Gain Cash and Carry" style="max-height: 50px; object-fit: contain;" /></b-col>
        </b-row>
    </section>
      <section id="developers">
      <b-jumbotron bg-variant="white" fluid header="API for Developers">
        <p>Integrate Umbai's airtime, data and grocery voucher services into your own applications using our developer API. Our well-documented REST API supports:</p>
        <ul>
          <li>Econet, NetOne, Taura and Telecel airtime top-up for Zimbabwe</li>
          <li>Data plan and bundle purchases</li>
          <li>ZESA token and bill payments</li>
          <li>Gain Cash and Carry grocery voucher purchases for Zimbabwe</li>
          <li>MTN, Vodacom, Telkom and Cell C airtime for South Africa</li>
          <li>TNM and Airtel airtime for Malawi</li>
        </ul>
        <p>
  <a target="_blank" href="https://documentation.umbai.africa"
     class="btn btn-outline-primary btn-round btn-lg" data-toggle="tooltip"
     data-original-title="Follow us">EXPLORE THE DEVELOPER DOCS</a>
</p>
        <p>To learn more and get started, send an email to support@umbai.co.za</p>
      </b-jumbotron>
    </section>
    <section id="about">
      <b-jumbotron bg-variant="white" fluid header="About Us">
        <p>Umbai Africa is your cross-border ecommerce platform for buying Econet airtime, NetOne airtime, Taura airtime, Telecel airtime, ZESA tokens and Gain Cash and Carry grocery vouchers online. We connect shoppers with reliable local fulfilment partners across Zimbabwe, Malawi and South Africa — shop online, collect locally. Our developer API enables businesses to integrate airtime, data and grocery voucher services into their own applications.</p>
      </b-jumbotron>
    </section>
    <section id="contact">
      <b-jumbotron bg-variant="white" fluid header="Contact Us">
        <b-row>
          <b-col>Call us: +27 67 740 5859 /<br /> +27 87 702 0660</b-col>
          <b-col>Whatsapp Us: +27 67 740 5859</b-col>
          <b-col>Email Us: support@umbai.co.za </b-col>
        </b-row>
      </b-jumbotron>
    </section>
    <div class="container">
      <div class="row">

        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
          <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
        </div>
        <div class="col-4 text-lg-center btn-wrapper">
          <a target="_blank" href="https://www.linkedin.com/company/umbairealities/"
            class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Follow us">
            <i class="fa fa-linkedin"></i>
          </a>
          <a target="_blank" href="https://www.facebook.com/umbai.co.za"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
            data-original-title="Like us">
            <i class="fa fa-facebook-square"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            Umbai all rights reserved
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Terms" class="nav-link">Terms</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Privacy" class="nav-link">Privacy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>




